import React from "react";
import styles from "../KpiForm.module.sass";
import { TextInput } from "colbi_web_ui/lib/components/inputs";
import { datetime } from "../../../../utils";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const HeadersTab = ({ KpiID, KpiType, CreatedAt, UpdatedAt, handleChange }) => {
    const { i18n } = useGlobalValue();

    return (
        <div className={styles["headers"]}>
            <div className={styles["input-field"]}>
                <TextInput
                    className={styles["input"]}
                    name={i18n`Identificador`}
                    value={KpiID || ""}
                    placeholder={i18n`Enter an identificator`}
                    onChange={(e) => {
                        handleChange(e, "KpiID", e.target.value);
                    }}
                />
            </div>
            <div className={styles["input-field"]}>
                <TextInput
                    className={styles["input"]}
                    name={i18n`kpi type`}
                    value={KpiType || ""}
                    placeholder={i18n`Enter a Kpi Type`}
                    onChange={(e) => {
                        handleChange(e, "KpiType", e.target.value);
                    }}
                />
            </div>
            <div className={styles["group-content"]}>
                <div className={styles["flex"]}>
                    <div className={styles["input-field"]}>
                        <TextInput
                            className={styles["input"]}
                            name={i18n`Created At`}
                            defaultValue={datetime(CreatedAt) || ""}
                            disabled
                        />
                    </div>
                    <div className={styles["input-field"]}>
                        <TextInput
                            className={styles["input"]}
                            name={i18n`Updated At`}
                            defaultValue={datetime(UpdatedAt) || ""}
                            disabled
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeadersTab;
